import { ReplaceText } from "../../LLM/ReplaceText";

import { ToolCallProps } from "@/taskpane/types/ToolCall";
import { Check, X } from "lucide-react";

type ReplaceTextToolProps = ToolCallProps<
	{
		text: string;
		update: string;
		before: string;
		after: string;
	},
	string
>;

export function ReplaceTextTool({ result, args }: ReplaceTextToolProps) {
	if (!args && result) {
		return (
			<div className="flex items-center gap-2 text-sm text-base-content/50 italic">
				<Check className="w-4 h-4" /> {result.toString()}
			</div>
		);
	}

	if (!args) {
		return (
			<div className="flex items-center gap-2 text-sm text-base-content/50 italic">
				<X className="w-4 h-4" /> Aucun paramètre fourni
			</div>
		);
	}

	return <ReplaceText {...args} />;
}
